import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output, Renderer2
} from '@angular/core';
import {BuilderSectionsInteractionService} from "../../builder-sections-interaction.service";
import {map} from "rxjs/operators";
import {Observable} from "rxjs/internal/Observable";
import {BuilderHistoryService} from "../../builder-history.service";
import {BuilderStepsEnum, BuilderTourEnum} from "../../builder-tour.enum";
import {User} from "@sentry/browser";
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {BuilderV2Service} from "../../builder-v2.service";
import {PageMetaI, SectionTemplateI} from "../../builder-v2.interface";
import {DragHelperService} from "../../services/drag-helper.service";
import {CanvasZoomService} from "../../services/canvas-zoom.service";
import {SinglePageService} from "../../single-page/services/single-page.service";
import {CommonBuilderDataService} from "../../services/common-builder-data.service";
import {Website} from "../../../websites/website/website";

@Component({
    selector: 'db-builder-canvas',
    templateUrl: './builder-canvas.component.html',
    styleUrl: './builder-canvas.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BuilderCanvasComponent implements OnInit {
  @Output() zoomToFit: EventEmitter<void> = new EventEmitter<void>();
  @Output() canvasScale: EventEmitter<number> = new EventEmitter<number>();
  @Input() pageMeta: PageMetaI[] = [];
  @Input() scale;
  @Input() website: Website;
  fakePages = [{}, {
    title: 'Page 1',
    id: 1,
    index: 1,
    slug: '',
    description: ''
  },
    {
      title: 'Page 2',
      id: 2,
      index: 2,
      slug: '',
      description: ''
    },
    {
      title: 'Page 3',
      id: 3,
      index: 3,
      slug: '',
      description: ''
    }
  ];
  singlePageFake = [{}, {
    title: 'New page',
    id: 1,
    index: 1,
    slug: '',
    description: ''
  }];
  @Input() popupMode;
  @Input() singlePage;
  isMobile = window.innerWidth <= 991;
  @Input() user: User;
  @Output() openMagicLink: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() set uniqueId(uniqueId: string) {
    if (!uniqueId) {
      return;
    }
    this.uniqueIdValue = uniqueId;
    this._getTemplatesList(uniqueId);
  }

  uniqueIdValue: string;
  sectionsLoaded$: Observable<boolean> = inject(BuilderSectionsInteractionService).pageLoaded.pipe(map(() => true));
  tourStep = inject(BuilderHistoryService).tourStep;
  tourSteps = BuilderTourEnum;
  sectionTemplates: SectionTemplateI[] = [];
  builderStep: any = BuilderStepsEnum;


  constructor(private _builderService: BuilderV2Service,
              private _activeModal: DbActiveModal,
              public builderInteractionsService: BuilderSectionsInteractionService,
              private _dragHelperService: DragHelperService,
              private _renderer: Renderer2,
              public singlePageService: SinglePageService,
              public _commonDataService:CommonBuilderDataService,
              private _canvasZoomService: CanvasZoomService,
              public builderHistoryService: BuilderHistoryService) {
  }

  ngOnInit() {
    this._activeModal.hideCloseBtn(true);
  }

  /*  panZoomChange(value: PanZoomModel) {
      // console.log(value);
      const zoom = Math.floor(value.zoomLevel * 100);
      this.canvasScale.emit(zoom);
    }*/

  private _getTemplatesList(uniqueId: string) {
    this._builderService.getTemplatesList(uniqueId)
      .subscribe((response) => {
        if (response && response.data) {
          this.sectionTemplates = response.data.filter(value =>  value.compatible_website_types.includes(this._commonDataService?.websiteType || 'basic'));
        }
      });
  }
}
